import { render, staticRenderFns } from "./RecurringsDetail.vue?vue&type=template&id=64c80b00&scoped=true"
import script from "./RecurringsDetail.vue?vue&type=script&lang=js"
export * from "./RecurringsDetail.vue?vue&type=script&lang=js"
import style0 from "./RecurringsDetail.vue?vue&type=style&index=0&id=64c80b00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c80b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c80b00')) {
      api.createRecord('64c80b00', component.options)
    } else {
      api.reload('64c80b00', component.options)
    }
    module.hot.accept("./RecurringsDetail.vue?vue&type=template&id=64c80b00&scoped=true", function () {
      api.rerender('64c80b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Recurrings/RecurringsDetail.vue"
export default component.exports